// List of navbar options
export const navigationOptions = [
    {
        'id'   : 'dashboard',
        'title': 'Dashboard',
        'type' : 'item',
        'icon' : 'home',
        'url'  : '/dashboard'
    },
    {
        'id'   : 'company',
        'title': 'Companies',
        'type' : 'item',
        'icon' : 'account_balance',
        'url'  : '/company',
    },
    {
        'id'   : 'instructor',
        'title': 'Instructors',
        'type' : 'item',
        'icon' : 'person',
        'url'  : '/instructor',
    },
    {
        'id'   : 'student',
        'title': 'Students',
        'type' : 'item',
        'icon' : 'people',
        'url'  : '/student',
    },
    {
        'id'   : 'major',
        'title': 'Majors',
        'type' : 'item',
        'icon' : 'school',
        'url'  : '/major',
    },
    {
        'id'   : 'course',
        'title': 'Courses',
        'type' : 'item',
        'icon' : 'book',
        'url'  : '/course',
    },
    {
        'id'   : 'assigned_course',
        'title': 'Assigned Courses',
        'type' : 'item',
        'icon' : 'grid_on',
        'url'  : '/scheduled_course',
    },
    {
        'id'   : 'module',
        'title': 'Modules',
        'type' : 'item',
        'icon' : 'ballot',
        'url'  : '/module',
    },
    {
        'id'   : 'lesson',
        'title': 'Lessons',
        'type' : 'item',
        'icon' : 'file_copy',
        'url'  : '/lesson',
    },
    {
        'id'   : 'assignment',
        'title': 'Assignments',
        'type' : 'item',
        'icon' : 'edit',
        'url'  : '/assignment',
    },
    {
        'id'   : 'quiz',
        'title': 'Quizzes',
        'type' : 'item',
        'icon' : 'reorder',
        'url'  : '/quiz',
    },
    {
        'id'   : 'gradebook',
        'title': 'Gradebook',
        'type' : 'item',
        'icon' : 'assignment',
        'url'  : '/gradebook',
    },
    {
        'id'   : 'student_event',
        'title': 'Events',
        'type' : 'item',
        'icon' : 'edit',
        'url'  : '/student/events',
    },
    {
        'id'   : 'student_lesson',
        'title': 'Lessons',
        'type' : 'item',
        'icon' : 'file_copy',
        'url'  : '/student/lessons',
    },
    {
        'id'   : 'student_course',
        'title': 'Courses',
        'type' : 'item',
        'icon' : 'book',
        'url'  : '/student/courses',
    },
    {
        'id'   : 'qualification',
        'title': 'Qualificiations',
        'type' : 'item',
        'icon' : 'done',
        'url'  : '/qualification',
    },
    {
        'id'   : 'enrollment',
        'title': 'Enrollment',
        'type' : 'item',
        'icon' : 'insert_invitation',
        'url'  : '/course_enrollment',
    },
    {
        'id'   : 'user',
        'title': 'Users',
        'type' : 'item',
        'icon' : 'account_circle',
        'url'  : '/user',
    },
    {
        'id'   : 'permission',
        'title': 'Permissions',
        'type' : 'item',
        'icon' : 'lock',
        'url'  : '/permission',
    },
    {
        'id'   : 'progress',
        'title': 'Progress',
        'type' : 'item',
        'icon' : 'grade',
        'url'  : '/progress',
    }
];

export const fuseNavigationConfig = [
    {
        'id'      : 'university',
        'title'   : 'University',
        'type'    : 'group',
        'icon'    : 'apps',
        'children': navigationOptions
    }
];


// WEBPACK FOOTER //
// src/fuse-configs/fuseNavigationConfig.js